/**
 * 공지사항 서비스
 */
import { db } from '../firebase/config';
import {
  collection, doc, getDoc, getDocs,
  addDoc, updateDoc, deleteDoc, serverTimestamp,
  query, orderBy,
} from 'firebase/firestore';

const COL = 'notices';

// ───── 공지 목록 (페이지네이션) ─────
export const getNotices = async (page = 1, perPage = 5) => {
  const q = query(
    collection(db, COL),
    orderBy('createdAt', 'desc')
  );

  const snap = await getDocs(q);
  const all = snap.docs
    .map((d) => ({
      id: d.id,
      ...d.data(),
      date: d.data().createdAt?.toDate?.()?.toISOString().slice(0, 10) || '',
      _doc: d,
    }))
    .filter((n) => n.isPublished !== false);

  const start = (page - 1) * perPage;
  return all.slice(start, start + perPage);
};

// ───── 공지 상세 ─────
export const getNoticeDetail = async (id) => {
  const snap = await getDoc(doc(db, COL, id));
  if (!snap.exists()) return null;
  const data = snap.data();
  return {
    id: snap.id,
    ...data,
    date: data.createdAt?.toDate?.()?.toISOString().slice(0, 10) || '',
  };
};

// ───── 공지 전체 건수 ─────
export const getNoticeCount = async () => {
  const q = query(collection(db, COL), orderBy('createdAt', 'desc'));
  const snap = await getDocs(q);
  return snap.docs.filter((d) => d.data().isPublished !== false).length;
};

// ───── 전체 목록 (관리자용, isPublished 무관) ─────
export const getAllNotices = async () => {
  const q = query(collection(db, COL), orderBy('createdAt', 'desc'));
  const snap = await getDocs(q);
  return snap.docs.map((d) => ({
    id: d.id,
    ...d.data(),
    date: d.data().createdAt?.toDate?.()?.toISOString().slice(0, 10) || '',
  }));
};

// ───── 공지 등록 ─────
export const createNotice = async (data) => {
  const ref = await addDoc(collection(db, COL), {
    title: data.title,
    content: data.content,
    category: data.category || '',
    target: data.target || '전체',
    isPublished: data.isPublished !== false,
    createdBy: data.createdBy || 'admin',
    createdAt: serverTimestamp(),
  });
  return ref.id;
};

// ───── 공지 수정 ─────
export const updateNotice = async (id, data) => {
  await updateDoc(doc(db, COL, id), {
    ...data,
    updatedAt: serverTimestamp(),
  });
};

// ───── 공지 삭제 ─────
export const deleteNotice = async (id) => {
  await deleteDoc(doc(db, COL, id));
};
